import { Box, styled } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

// ── Legacy MUI wrappers re-exported so existing consumers (e.g. dm-page) ──────
// ── continue to compile without modification. ─────────────────────────────────

export const InvitePlayerPageWrapper = styled(Box)(() => ({
  position: 'relative',
}));

export const InvitePlayerPageContentWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(1),
  gridTemplateRows: 'auto',
  overflowY: 'auto',
  overflowX: 'hidden',
  '& > div': {
    selfAlign: 'center',
    justifySelf: 'center',
    width: '100%',
  },
}));

/**
 * Outer shell for the invite-players tab.
 *
 * Fills its (bounded) parent: the invite screen is `100dvh` minus the measured
 * top bar (`--bh-topbar-h`, incl. the notch) and the keyboard, so no
 * page-level scroll occurs; only the list region below scrolls if needed.
 *
 * `head` (search bar + optional info banner) and `foot` (pagination) are
 * rendered outside the scrollable area so they always stay on screen.
 */
export const InvitePlayerPageLayout: FC<
  PropsWithChildren<{ head?: ReactNode; foot?: ReactNode }>
> = ({ children, head, foot }) => (
  <div
    className="flex flex-col px-3 container mx-auto"
    style={{ height: '100%' }}
  >
    {/* Header section – search bar, banners */}
    {head && <div className="flex-shrink-0 py-3">{head}</div>}

    {/* Scrollable user list — fills remaining space */}
    <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
      {children}
    </div>

    {/* Footer – pagination always visible */}
    {foot && (
      <div
        className="flex-shrink-0 py-2"
        style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom))' }}
      >
        {foot}
      </div>
    )}
  </div>
);
